import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './breadCrumb.scss';

type BreadcrumbData = {
  title: string;
  path?: string;
  badge?: string;
  badgeType: string;
};

interface LocationState {
  breadCrumbLinks?: BreadcrumbData[];
  [key: string]: any; // Other possible state parameters
}

export default function Breadcrumbs() {
  const { state, pathname } = useLocation();
  const { breadCrumbLinks = [] } = (state as LocationState) || {};

  return (
    <div className="container-fluid">
      <div className="row py-2 grc-breadcrumbs px-0">
        <div className="col px-0">
          <nav className="bread-crumbs" aria-label="breadcrumb">
            <>
              {breadCrumbLinks &&
                breadCrumbLinks.length > 0 &&
                breadCrumbLinks.map((breadCrumb, index) => {
                  return (
                    <span className="main-breadcrum" key={breadCrumb.title}>
                      {/* {index !== 0 && <ChevronIcon className="ms-2 me-2" />} */}
                      {breadCrumb.path && breadCrumb.path !== pathname ? (
                        <Link
                          className="bread-crumb-link"
                          to={breadCrumb.path}
                          state={{
                            breadCrumbLinks: breadCrumbLinks.slice(0, index + 1)
                          }}
                        >
                          {breadCrumb.title}
                        </Link>
                      ) : (
                        breadCrumb.title
                      )}
                      {!!breadCrumb.badge && (
                        <span className={`grc-b mx-2 ${breadCrumb.badgeType}`}>
                          {breadCrumb.badge}
                        </span>
                      )}
                    </span>
                  );
                })}
            </>
          </nav>
        </div>
      </div>
    </div>
  );
}
